import CustomButton from "../../../common/CustomButton";
import Lottie from "lottie-react";
import WomanWorkout from "../../user-onboarding/animations/WomanWorkout.json";


function WelcomePage({ moveNext, backLogin }) {
    return (
        <div id="uo-welcome-page" className="uo-wp-resurvey-page uo-component div-35-65">
            <div id="uo-pi-pm-animation-banner">
                <div id="uo-pi-pm-ab-container">
                    <Lottie className="workout-animation" animationData={WomanWorkout} loop={true} />
                </div>
            </div>
            <div id="uo-wp-text" className="bottom-text-area">
                <h4>Time to Upgrade Your Workouts!</h4>
                <h6>We’ve enhanced the way that you can build your routine with indi. Take a quick survey so we can build your custom schedule with the same programs you know and love!</h6>
                <CustomButton className="uo-button active" onClick={moveNext}>Build Your Routine</CustomButton>
                <div id="uo-wp-t-curve-shapes">
                    <img src="/assets/images/onboarding/onboarding-banner-curve-shapes.png" />
                </div>
            </div>
        </div>
    );
}

export default WelcomePage;